import { useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Clock3, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { trackEvent } from "@/utils/analytics";
import { BIZ } from "@/constants/content";

export default function ThankYouLabel() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent("generate_label_request", { ref });
  }, [ref]);

  return (
    <div className="blueprint flex min-h-screen items-center justify-center bg-paper p-4">
      <div className="w-full max-w-lg rounded-[24px] border border-ink/10 bg-white p-8 text-center shadow-[0_30px_80px_rgba(22,50,79,0.15)] sm:p-10" data-testid="label-thankyou-card">
        <button onClick={() => navigate("/")} className="mx-auto block" data-testid="thankyou-logo-link" aria-label="JSL Dental Repair home">
          <Logo />
        </button>
        <span className="mt-7 inline-flex rounded-full bg-brandleaf-soft p-4">
          <CheckCircle2 className="h-9 w-9 text-brandleaf-deep" />
        </span>
        <h1 className="font-display mt-5 text-2xl font-extrabold text-ink">Request received!</h1>
        <p className="mt-3 text-[14.5px] leading-relaxed text-slate-600" data-testid="thankyou-message">
          Thank you for choosing JSL Dental Repair! Your prepaid shipping-label request
          {ref ? (<span> <span className="font-mono font-bold text-ink" data-testid="thankyou-ref">{ref}</span></span>) : null} has
          been received and is <strong className="text-ink">pending approval</strong>. Once approved, your label will
          be sent directly to your email.
        </p>
        <div className="mt-6 flex items-center justify-center gap-2 rounded-2xl bg-cloud px-4 py-3 text-[13px] font-semibold text-ink">
          <Clock3 className="h-4 w-4 text-brandsky-deep" />
          Approvals usually happen the same business day.
        </div>
        <p className="mt-5 text-[13px] text-slate-500">
          Questions? Call or text{" "}
          <a href={BIZ.jacob.tel} className="font-bold text-ink" data-testid="thankyou-call-link">{BIZ.jacob.phone}</a>
        </p>
        <Link to="/" className="mt-7 inline-block text-[13px] font-semibold text-slate-400 hover:text-ink" data-testid="thankyou-back-link">
          ← Back to the website
        </Link>
      </div>
    </div>
  );
}